import { useEffect, useState } from 'react';
import { CMS_HUB_PROFESSIONAL } from 'self-service-api/constants/ProductNames';
import { isProApiName } from 'ui-addon-upgrades/_core/trial/SurveyResponses';
import { HC0119_GROUP_PARAMETER_KEY, HC0119_GROUP_PARAMETER_OPTIONS, HC0119_TREATMENT_KEY, PARAMETERS } from '../constants/experimentKeys';
import { laboratoryClient } from '../utils/laboratoryClient';
export const logHC0119Exposure = () => {
  laboratoryClient.logExposure(HC0119_TREATMENT_KEY);
};
export const useIsHC0119Variant = apiName => {
  const [isHC0119Variant, setIsHC0119Variant] = useState(false);
  const [isHC0119Fetched, setIsHC0119Fetched] = useState(false);
  const [isEligibleForHC0119, setIsEligibleForHC0119] = useState(false);
  useEffect(() => {
    if (!isHC0119Fetched) {
      if (apiName !== undefined && isProApiName(apiName) && apiName !== CMS_HUB_PROFESSIONAL) {
        setIsEligibleForHC0119(true);
        laboratoryClient.resolve(treatments => {
          if (Object.keys(treatments).length) {
            const treatment = treatments[HC0119_TREATMENT_KEY];
            const cohort = treatment[PARAMETERS][HC0119_GROUP_PARAMETER_KEY];
            const isVariant = cohort === HC0119_GROUP_PARAMETER_OPTIONS.variant;
            setIsHC0119Variant(isVariant);
          }
          setIsHC0119Fetched(true);
        });
      } else {
        setIsHC0119Variant(false);
        setIsHC0119Fetched(true);
        setIsEligibleForHC0119(false);
      }
    }
  }, [apiName, isHC0119Fetched]);
  return {
    isHC0119Variant,
    isHC0119Fetched,
    isEligibleForHC0119
  };
};